
  export default {
    props: { cssClass: { type: String, default: null }, stars: { type: Number, default: 5 } },
    computed: {
      starStyle () { return { width: `${(this.stars * 20)}%` }; }
    }
  };
